const getEmbedRoot = state => state.embed;
export const getEmbedId = state => getEmbedRoot(state).embedId;
export const getIsEmbedded = state => Boolean(getEmbedId(state));
export const getSourceApp = state => getEmbedRoot(state).sourceApp;
export const getEmailSendingAppId = state => getEmbedRoot(state).emailSendingAppId;
export const getEmptyStateName = state => getEmbedRoot(state).emptyStateName;
export const getIsSimpleConfigPanel = state => getEmbedRoot(state).isSimpleConfigPanel;